import { MetricSelectScene } from '../MetricSelectScene';

export function buildRelatedMetricsScene() {
  return new MetricSelectScene({});
}
